import { css } from '@emotion/css';
import { BUTTON_VARIANT } from './styles/styleVariant';
import { BUTTON_TEXT_SIZE, BUTTON_ICON_SIZE, ICON_SIZE, ICON_GAP } from './styles/styleSize';

const styBaseButton = css`
  display: flex;
  justify-content: center;
  align-items: center;

  border: unset;
  border-radius: 4px;
  outline: none;
  box-shadow: none;

  font-weight: 700;
  font-family: 'Lato';
  font-style: normal;

  cursor: pointer;

  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  :disabled {
    cursor: not-allowed;
  }
  :focus {
    outline: none;
  }
`;

export const styBtn = (props) => css`
  ${styBaseButton}
  ${BUTTON_VARIANT[props.variant]}
  ${props.type === 'text' && BUTTON_TEXT_SIZE[props.size]}
  ${props.type === 'text-icon' && BUTTON_TEXT_SIZE[props.size]}
  ${props.type === 'icon' && BUTTON_ICON_SIZE[props.size]}

  ${props.fluid && 'width: 100%;'}
  ${props.minWidth && { minWidth: props.minWidth }}
`;

export const styBtnTextIcon = (props) => css`
  display: flex;
  align-items: center;

  img,
  svg,
  .loader {
    ${props.iconPosition === 'left' && `margin-right: ${ICON_GAP[props.size]};`}
    ${props.iconPosition === 'right' && `margin-left: ${ICON_GAP[props.size]};`}
    ${ICON_SIZE[props.size]}
  }
`;

export const styBtnIcon = (props) => css`
  display: flex;

  img,
  svg,
  .loader {
    ${ICON_SIZE[props.size]}
  }
`;
